import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MainSubContainer, MobileHeader, Title, InventoryContainer } from './index.styled';
import { useSelector, useDispatch } from 'react-redux';
import {
    resetItemTableData,
    reSetProgressBarStatus,
    resetSurgeryDetails,
    setConsignmentCUInProgress,
    setConsignmentUnsavedChangesPopUp,
    setProgressBarStatus,
    setScheduleSurgeryUnsavedChangesPopUp,
} from 'src/pages/consignmentBilling/redux/actions';
import InventoryHeader from './InventoryHeader';
import InventorySearch from './InventorySearch';
import InventoryBody from './InventoryBody';
import InventoryFooter from './InventoryFooter';
import { useHistory } from 'react-router-dom';
import ArrowLeft from 'src/assets/images/ArrowLeftBack.svg';
import { getInventoryDetails } from '../../redux/actions';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import { CFN } from './inventoryData.js';
import { getRoutePathWithParams, logErrorToConsole, navLinkSelectHandler } from 'src/utils/util';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import { pageNames, VISIBLE } from 'src/constants/appConstants';
import UnsavedChanges from '../common/notifications/UnsavedChanges';
import { useTranslation } from 'react-i18next';
import { setActiveNavLink } from 'src/pages/home/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { useViewportHeight } from '../../hooks/useViewportHeight';

const ConsignmentInventory = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    
    // iPad Chrome keyboard fix: Set --vh CSS variable for consistent viewport height
    // useViewportHeight();
    const [itemsCheckedCount, setItemCheckedCount] = useState(0);
    const [searchItem, setSearchItem] = useState('');
    const [filterCheckedItems, setFilterCheckedItems] = useState([]);
    const [qtyVal, setQtyVal] = useState(1);
    const [showBtn, setShowBtn] = useState(false);
    const [inputVal, setInputVal] = useState('');
    const [itemsVal, setItemsVal] = useState([]);
    const [checked, setChecked] = useState([]);
    const [valid, setQtyValid] = useState(false);
    const [clrAll, setClrAll] = useState(false);
    const [modifiedData, setModifiedData] = useState([]);
    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);
    const [sortOrderName] = useState('ASC');
    const [sortParams, setSortParams] = useState(CFN);

    const [pageNo, setPageNo] = useState(0);
    const [sortOrder, setSortOrder] = useState('ASC');
    const { t } = useTranslation();

    const { bannerHeight } = useSelector((state) => state.loginReducer);
    const accountId = useSelector(
        (state) => state.consignmentReducer.surgeryDetails.accountId.accountId
    );
    const unsavedChangesPopUp = useSelector(
        (state) => state.consignmentCommonReducer.unsavedChangesPopUp
    );
    const routePathForConsignmentUnsavedChangesPopUp = useSelector(
        (state) =>
            state.consignmentCommonReducer
                .routePathForConsignmentUnsavedChangesPopUp
    );

    const { countryISOCode, specialStockPartner,specialStockPartnerVisibility } = useSelector((state) => ({
        countryISOCode: state.loginReducer?.hybrisUserDetails.countryISOCode,
        specialStockPartner:
            state.consignmentReducer.surgeryDetails.specialStockPartnerDetails,
        specialStockPartnerVisibility:
            state.loginReducer.specialStockPartnerDetails,
    }));

    const { isShortTermConsignment } = useSelector((state) => ({
        isShortTermConsignment:
            state.consignmentReducer.surgeryDetails.isShortTermConsignment,
    }));

    const onPageChange = (event) => {
        setFirst(event.first);
        setPage(event.page);
        setPageNo(event.pageNo);
    };

    useEffectWithErrorLogging(() => {
        const payload = {
            accountNumber:
            specialStockPartner
                    ? specialStockPartner?.sbNumber
                    : accountId,
            productType: 'tissue',
            orderType: 'KE',
            resourceType: 'INVENTORY_LIST',
            sortCode: 'cfn',
            sortOrder: sortOrderName,
            currentPage: page,
            pageSize: '50',
            filterParam: 'all',
            searchQuery: searchItem,
           isBKPProductsDisplay: isShortTermConsignment ? true : false,
        };
        dispatch(getInventoryDetails(payload));
    }, [location, page, sortOrderName]);

    useEffectWithErrorLogging(() => {
        window.scrollTo(0, 0);
    }, [searchItem]);

    const inventoryData = useSelector(
        (state) => state.inventoryReducer.inventoryData
    );
    const totalResults = useSelector(
        (state) => state.inventoryReducer.totalResults
    );
    const loading = useSelector((state) => state.inventoryReducer.loading);

    // useEffectWithErrorLogging(()=>{
    //     inventoryData && inventoryData.forEach(object => {
    //         object.flag = false;
    //       });
    //       console.log('arr',inventoryData);
    // },[inventoryData])
    const setConsignmentCUInProgressLocal = (value) => {
        if (!value) {
            window.onbeforeunload = null;
        }
        dispatch(setConsignmentCUInProgress(value));
    };
    const handleDiscardChanges = () => {
        let path = routePathForConsignmentUnsavedChangesPopUp.path;
        setConsignmentCUInProgressLocal(false);
        dispatch(setConsignmentUnsavedChangesPopUp(false));
        dispatch(reSetProgressBarStatus());
        dispatch(resetSurgeryDetails());
        dispatch(resetItemTableData());
        navLinkSelectHandler(
            dispatch,
            setActiveNavLink,
            routePathForConsignmentUnsavedChangesPopUp.selectOption
        );

        if (path.includes('http')) {
            window.location.href = path;
        } else {
            history.push(getRoutePathWithParams(path));
        }
    };

    const sortChangeHandler = (sortParamsValue, sortOrderValue) => {
        let sortCodeAPI = '';
        let sortOrderAPI = '';
        if (sortParamsValue !== sortParams) {
            setSortParams(sortParamsValue);
            setSortOrder('ASC');
            sortCodeAPI = sortParamsValue;
            sortOrderAPI = 'ASC';
        } else {
            setSortOrder(sortOrderValue === 'ASC' ? 'DESC' : 'ASC');
            sortCodeAPI = sortParams;
            sortOrderAPI = sortOrderValue === 'ASC' ? 'DESC' : 'ASC';
        }

        const payload = {
            accountNumber:
            specialStockPartnerVisibility === VISIBLE && specialStockPartner
                    ? specialStockPartner?.sbNumber
                    : accountId,
            productType: 'tissue',
            orderType: 'KE',
            resourceType: 'INVENTORY_LIST',
            sortCode: sortCodeAPI,
            sortOrder: sortOrderAPI,
            currentPage: pageNo,
            pageSize: '50',
            filterParam: 'all',
            searchQuery: searchItem,
            isBKPProductsDisplay: isShortTermConsignment ? true : false,
        };
        dispatch(getInventoryDetails(payload));
    };
    useDynatracePageName(pageNames.consignmentBillingInventory);

    return (
        <InventoryContainer bannerHeight={bannerHeight}>
            {loading && (
                <Backdrop
                    showCloseButton={false}
                    showBackdrop={true}
                    isModal
                    loaderBackground
                >
                    <Spinner id="consignmentBilling-inventory-inventory-loadingSpinner" animation="border" variant="primary" small />
                </Backdrop>
            )}
            <MobileHeader>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: '16px',
                    }}
                >
                    <img
                        id={`consignmentBilling-inventory-backIcon-${accountId || 'default'}`}
                        src={ArrowLeft}
                        alt="back"
                        onClick={() => {
                            try {
                                history.push(getRoutePathWithParams('/consignmentBilling'));
                                dispatch(setProgressBarStatus('Account'));
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                        style={{
                            height: '18px',
                            width: '11px',
                        }}
                    />
                </div>
                <Title>{t('consignmentBilling.inventory.addFromInventory')}</Title>
            </MobileHeader>
            <MainSubContainer smalDeviceMargin={'91%'}>
                <InventoryHeader />
                <InventorySearch
                    setSearchItem={setSearchItem}
                    setShowBtn={setShowBtn}
                    filterCheckedItems={filterCheckedItems}
                    checked={checked}
                    setChecked={setChecked}
                    setFilterCheckedItems={setFilterCheckedItems}
                    itemsCheckedCount={itemsCheckedCount}
                    setItemCheckedCount={setItemCheckedCount}
                    setClearAll={(value) => {
                    }}
                    itemsVal={itemsVal}
                    setItemsVal={setItemsVal}
                    setModifiedData={setModifiedData}
                    searchItem={searchItem}
                />

                <InventoryBody
                    inventoryDetails={
                        modifiedData.length > 0 ? modifiedData : inventoryData
                    }
                    setItemCheckedCount={setItemCheckedCount}
                    setFilterCheckedItems={setFilterCheckedItems}
                    setQtyVal={setQtyVal}
                    qtyVal={qtyVal}
                    setInputValue={(value) => {
                        setInputVal(value);
                    }}
                    setItemsVal={(value) => setItemsVal(value)}
                    filterCheckedItems={filterCheckedItems}
                    checked={checked}
                    setChecked={setChecked}
                    itemsVal={itemsVal}
                    setValid={(valid) => {
                        setQtyValid(valid);
                    }}
                    clrAll={clrAll}
                    sortOrder={sortOrder}
                    setSortOrder={setSortOrder}
                    sortParams={sortParams}
                    setSortParams={setSortParams}
                    sortChangeHandler={sortChangeHandler}
                />
            </MainSubContainer>
            <InventoryFooter
                itemsCheckedCount={itemsCheckedCount}
                inventoryDetails={inventoryData}
                filterCheckedItems={filterCheckedItems}
                qtyVal={qtyVal}
                inputVal={inputVal}
                showBtn={showBtn}
                itemsVal={itemsVal}
                valid={valid}
                setChecked={setChecked}
                page={page}
                setPage={setPage}
                first={first}
                setFirst={setFirst}
                onPageChange={onPageChange}
                totalResults={totalResults}
                searchItem={searchItem}
                checked={checked}
            />
            {unsavedChangesPopUp && (
                <UnsavedChanges
                    onDiscard={() => handleDiscardChanges()}
                    onClose={() =>
                        dispatch(setScheduleSurgeryUnsavedChangesPopUp(false))
                    }
                />
            )}
        </InventoryContainer>
    );
};

export default ConsignmentInventory;
